/**
 * Shell-level mount of the workspace invitation modal: wherever the signed-in
 * user is, a never-dismissed pending invitation opens it in the centre of
 * the page (Figma 10216:3390).  Reads everything from
 * `PendingInvitationsProvider`; nothing renders while no session is open.
 */
import React from 'react';
import { usePendingInvitations } from './PendingInvitationsProvider';
import WorkspaceInvitationModal from './WorkspaceInvitationModal';

export default function WorkspaceInvitationGate() {
    const { current, position, total, busy, accept, decline, dismiss } = usePendingInvitations();
    return (
        <WorkspaceInvitationModal
            open={Boolean(current)}
            invitation={current}
            position={position}
            total={total}
            busy={busy}
            onAccept={accept}
            onDecline={decline}
            onClose={dismiss}
        />
    );
}
